export const rentalData = [
    {
        id: "RNT-001",
        slot: "P-103",
        floor: "Floor 1",
        rentedTo: "Centrum IT",
        rentalPeriodStart: "2026-08-20",
        rentalPeriodEnd: "2027-08-20",
        monthlyRent: 3500,
        status: "Pending", // Pending Site Acceptance
        createdAt: "2026-08-21",
        provider: "Unit A",
        renter: "Site Management",
        securityDeposit: 7000,
        site: "Main Logistics Hub",
        building: "Warehouse B, Floor 2",
        exactPlacement: "Server Rack 12-A"
    },
    {
        id: "RNT-002",
        slot: "P-104",
        floor: "Floor 1",
        rentedTo: "Centrum IT",
        rentalPeriodStart: "2026-08-20",
        rentalPeriodEnd: "2027-08-20",
        monthlyRent: 3500,
        status: "Active",
        createdAt: "2026-08-20",
        provider: "Unit A",
        renter: "Site Management",
        securityDeposit: 7000,
        site: "Main Logistics Hub",
        building: "Warehouse B, Floor 2",
        exactPlacement: "Server Rack 12-A"
    }
];

export const mockEligibleSlots = [
    { id: "A-102", label: "Slot A-102", details: "Floor 1 • 4 Wheeler (Car)", available: true },
    { id: "A-103", label: "Slot A-103", details: "Floor 1 • 4 Wheeler (Car)", available: true },
    { id: "A-104", label: "Slot A-104", details: "Floor 2 • 2 Wheeler (Bike)", available: true },
    { id: "A-106", label: "Slot A-106", details: "Floor 2 • 2 Wheeler (Bike)", available: true },
    { id: "A-107", label: "Slot A-107", details: "Floor 2 • 2 Wheeler (Bike)", available: true },
    { id: "A-108", label: "Slot A-108", details: "Floor 2 • 2 Wheeler (Bike)", available: true }
];
